import React, { Component } from 'react';
import {BASE_PATH, STATUS_NAME} from "../../../../../wpconfig";
import {NavLink} from "react-router-dom";
import { useHistory } from "react-router-dom";

class JItem extends Component {
  constructor(props) {
    super(props);

    this.copy = this.copy.bind(this)
  }

  tolinkDetail = (event) => {
    const t = window.location.href.split("?")[1].replace(/[\?&]record_id=[^&]+/, '')
    return BASE_PATH + "wp-admin/admin.php?" + t +
                "&record_id=" + this.props.record.journal_id;
  }

  copy = (type) => {
    const textarea = document.createElement("textarea");
    textarea.value = this.props.record[type];
    textarea.style.top = 0;
    textarea.style.left = 0;
    textarea.style.position = "fixed";

    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);
    this.props.showMessage("클립보드에 복사되었습니다.")
  }

  render() {
    const record = this.props.record;
    return (
      <tr>
        <td>{this.props.no}</td>
        <td>
          <NavLink to={this.tolinkDetail}>{record.journal_title}</NavLink>
          <span className="btn btn-outline-dark db-check-title" onClick={() => this.copy('journal_title')}>CT</span>
          <span className="btn btn-outline-dark db-check-title" onClick={() => this.copy('journal_id')}>CI</span>
        </td>
        <td>
          {!record.journal_status ? <span className="badge badge-item-status bg-danger">확인필요</span>
              : record.journal_status === 'publish' ? <span className="badge badge-item-status badge-success">{STATUS_NAME[record.journal_status]}</span>
                  : record.journal_status === 'draft' ? <span className="badge badge-item-status badge-warning">{STATUS_NAME[record.journal_status]}</span>
                      : record.journal_status === 'trash' ? <span className="badge badge-item-status badge-dark">{STATUS_NAME[record.journal_status]}</span>
                          : record.journal_status === 'unpublish' ? <span className="badge badge-item-status badge-secondary">{STATUS_NAME[record.journal_status]}</span>
                              : ''
          }
        </td>
      </tr>
    )
  }
}

export default JItem;